import { TeamInviteAccept } from "./pageComponents";

const TeamInviteAcceptRoute = () => {
  return <TeamInviteAccept />;
};

export default TeamInviteAcceptRoute;
